import { DestroyRef } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Flight } from "../../models/flight.model";
import { buildCrewArray } from "../tabs/crew/crew-members-group/crew-members-group";
import { buildEnginePowerCheckGroup } from "../tabs/engine-power-check/engine-power-check-group";
import { buildHoistArray } from "../tabs/hoist/hoist-group";
import { buildHookArray } from "../tabs/hook/hook-group";
import { buildFlightFuelGroup } from "../tabs/flight/fuel-group/fuel-group";
import { buildOilArray } from "../tabs/oil/oil-group";
import { buildPenaltyFactorGroup } from "../tabs/penalty-factor/penalty-factor-group";
import { buildRefuelArray } from "../tabs/refuel/refuel-group";
import { watchHeadcount } from "../tabs/crew/passengers-group/passengers-group";
import { FlightEditLookups } from "./flight-edit-lookups";
import { buildFlightGroup } from "./flight-form-group";

/** One group or array per part of the flight; each is built by the file next to the tab or group that shows it. */
export function buildFlightEditForm(flight: Flight, lookups: FlightEditLookups, destroyRef: DestroyRef) {
    const form = new FormGroup({
        flight: buildFlightGroup(flight, lookups, destroyRef),
        fuel: buildFlightFuelGroup(flight, lookups.fuelUnits, lookups.maxTank, destroyRef),
        hooks: buildHookArray(flight.hooks),
        hoists: buildHoistArray(flight.hoists),
        enginePowerCheck: buildEnginePowerCheckGroup(flight.enginePowerCheck),
        penaltyFactor: buildPenaltyFactorGroup(flight.penaltyFactor),
        refuels: buildRefuelArray(flight.refuelBeforeFirstFlight, lookups.fuelUnits, lookups.maxTank, destroyRef),
        oils: buildOilArray(flight.oilSuppliedBeforeFlight, lookups.oilUnits),
        crews: buildCrewArray(flight.crewData, lookups, destroyRef),
    });
    watchHeadcount(form.controls.flight, form.controls.crews, lookups.configs.headcount, destroyRef);
    return form;
}

export type FlightEditForm = ReturnType<typeof buildFlightEditForm>;
